import { useState } from 'react';
import { Group, SegmentedControl, SimpleGrid, Stack, Text } from '@mantine/core';

import { PLANS, type BillingCycle } from './plans';
import { PlanCard } from './PlanCard';

interface PricingGridProps {
  initialCycle?: BillingCycle;
  showToggle?: boolean;
}

export function PricingGrid({ initialCycle = 'monthly', showToggle = true }: PricingGridProps) {
  const [cycle, setCycle] = useState<BillingCycle>(initialCycle);

  return (
    <Stack gap="xl">
      {showToggle && (
        <Group justify="center">
          <SegmentedControl
            value={cycle}
            onChange={(v) => setCycle(v as BillingCycle)}
            data={[
              { label: 'Monthly', value: 'monthly' },
              { label: 'Yearly · save 36%', value: 'annual' },
            ]}
            color="forge"
            radius="md"
            size="md"
            aria-label="Billing cycle"
          />
        </Group>
      )}

      <SimpleGrid cols={{ base: 1, md: 3 }} spacing="lg">
        {PLANS.map((plan) => (
          <PlanCard key={plan.id} plan={plan} cycle={cycle} />
        ))}
      </SimpleGrid>

      <Text ta="center" size="xs" c="var(--tf-text-muted)">
        All plans include free updates within the same major version. Cancel anytime.
      </Text>
    </Stack>
  );
}
